export function isTextAboutMoney(text: string): boolean {
  // List of keywords related to money or currency
  const moneyKeywords = [
    "paid",
    "revenue",
    "money",
    "currency",
    "income",
    "expense",
    "payment",
    "profit",
    "collectible",
    "cost",
    "salary",
    "wage",
    "bill",
    "debt",
    "cash",
    "funds",
    "earnings",
    "balance",
    "price",
    "amount",
    "rent",
    "utilities",
  ];

  // Convert text to lowercase and check for any keyword
  const lowercaseText = text.toLowerCase();

  return moneyKeywords.some((keyword) => lowercaseText.includes(keyword));
}
